import { APP, ALIGN, VALIGN } from '_pixiSrc/globals';
import Sprite from '_pixiSrc/display/Sprite';
import { Utils } from '_pixiSrc/Utils';
import I18 from '_pixiSrc/I18';
import {
    GAME_DATA_KEY,
    GAME_PROPERTY_KEY,
} from '../Constants';
import Button from '../ui/Button';
import TurboButton from '../ui/TurboButton';
import Static from '../libraries/Static';
import DynamicData from './DynamicData';
import ScreenLocker from './ScreenLocker';
import GambleGame from '../gameEngine/GambleGame';
import TextPanel from './TextPanel';
import GameData from './GameData';
import BigWin from './BigWin';
import AudioManager from './AudioManager';
import Paytable from './Paytable';
import GameConfig from '../libraries/GameConfig';
import SpinButton from './SpinButton';
import NetworkController from '../network/NetworkController';
import SwitchButton from './SwitchButton';

class UI extends Sprite {
    constructor(x = 0, y = 0) {
        super();

        this.position.set(x, y);

        this.betPanel = {};
        this.walletPanel = {};
        this.informPanelFG = {
            visible: false,
        };

        this.buttons = {};
        this.buttonsGamble = {};
        this.switchers = {};
        this.isCollected = false;

        this.expandingBookPosition = {
            start: {
                x: 0,
                y: -200,
            },
            end: {
                x: -240,
                y: -10,
                scale: 0.65,
            },
        };

        this.bgExpPosition = {
            x: 0,
            y: -200,
        };

        this.once('added', Utils.proxy(this._init, this));
    }

    /**
   * @name setNextBet
   * @param direct
   * @description increase and decrease bet amount
   */
    setNextBet(direct = 1) {
        /**
     * check direct is grater than zero
     * then increase bet amount
     * else decrease bet amount
     */
        if (direct > 0) {
            /**
       * Request to server for increase bet amount
       */
            NetworkController.increaseBet((response) => {
                DynamicData.setValue(GAME_DATA_KEY.TOTALBET, response.totalBet);
                DynamicData.setValue(GAME_DATA_KEY.BET, response.currentBet);
            });
        } else {
            /**
       * Request to server for decrease bet amount
       */
            NetworkController.decreaseBet((response) => {
                DynamicData.setValue(GAME_DATA_KEY.TOTALBET, response.totalBet);
                DynamicData.setValue(GAME_DATA_KEY.BET, response.currentBet);
            });
        }
    }

    resizeUI(calculatedSize) {
        const screenWidth = calculatedSize.screenWidth || 1280;
        const screenHeight = calculatedSize.screenHeight || 1280;
        this.panelBackground.scale.set((screenWidth / this.panelBackground.asset.width) * 1.20, 0.75);
    }

    _init() {
        this.panelBackground = this.addChild(APP.library.getSprite('buttons/buttons/background'));
        this.panelBackground.position.set(0, 25);

        this.switchers.maxBet = this.addChild(new Button('buttons/buttons/max-bet', -68, -20, 0.65, () => {
            NetworkController.maxBet((response) => {
                DynamicData.setValue(GAME_DATA_KEY.TOTALBET, response.totalBet);
                DynamicData.setValue(GAME_DATA_KEY.BET, response.currentBet);
            });
        }));
        this.switchers.maxBet.hitArea = new PIXI.Circle(0, 0, 46);

        this.buttons.autoButton = this.addChild(new SwitchButton('buttons/buttons/autospin', 68, -20, 0.65));
        this.buttons.autoButton.hitArea = new PIXI.Circle(0, 0, 46);

        this.buttons.spin = this.addChild(new SpinButton('buttons/buttons/spin', 0, -30, 0.65));
        this.buttons.spin.hitArea = new PIXI.Circle(0, 0, 63);

        this.switchers.s1 = this.addChild(new Button('buttons/buttons/plus', -130, -17, 0.65, () => {
            this.setNextBet(1);
        }));
        this.switchers.s1.hitArea = new PIXI.Circle(0, 0, 27);

        this.switchers.s2 = this.addChild(new Button('buttons/buttons/minus', -380, -17, 0.65, () => {
            this.setNextBet(-1);
        }));
        this.switchers.s2.hitArea = new PIXI.Circle(0, 0, 27);

        this.betPanel = this.addChild(APP.library.getSprite('buttons/buttons/win'));
        this.betPanel.scale.set(0.65);
        this.betPanel.position.set(-255, -17);
        this.betPanel.betText = Static.writeNativeText(this.betPanel, I18.f('bet'), 'lato-regular', 0, -42, {
            fill: 0x3e0700,
            size: 22,
            stroke: 0xfcd781,
            strokeThickness: 8,
            align: ALIGN.CENTER,
            weight: 'bold',
        });

        this.betPanel.bet = DynamicData.writeNativeText(this.betPanel, GAME_DATA_KEY.TOTALBET, 'lato-regular', 0, 0, {
            spaceDivider: true,
            fill: 0xfcd781,
            align: ALIGN.CENTER,
            weight: 'bold',
            size: 22,
        }, null, {
            width: 175,
            minScale: 0.65,
            maxScale: 1,
        });

        this.informPanel = this.addChild(APP.library.getSprite('buttons/buttons/win'));
        this.informPanel.scale.set(0.65);
        this.informPanel.position.set(230, -17);
        this.informPanel.winText = Static.writeNativeText(this.informPanel, I18.f('win'), 'lato-regular', 0, -42, {
            fill: 0x3e0700,
            size: 22,
            stroke: 0xfcd781,
            strokeThickness: 8,
            align: ALIGN.CENTER,
            weight: 'bold',
        });

        this.informPanel.informString = TextPanel.writeText(this.informPanel, 'lato-regular', 0, 0);

        this.buttons.info = this.addChild(new Button('buttons/buttons/info', 380, -17, 0.65)); this.buttons.info.hitArea = new PIXI.Circle(0, 0, 27);
        this.buttons.info.clickAction = () => this.openInfo();

        this.buttons.turbo = this.addChild(new TurboButton('buttons/buttons/fastplay', -354, 23, 0.65, GAME_PROPERTY_KEY.TURBOCHECKED));
        this.buttons.turbo.clickAction = () => {
            const isTurboChecked = GameData.getProperty(GAME_PROPERTY_KEY.TURBOCHECKED);
            NetworkController.updateTuroEvent(isTurboChecked, false);
        };

        this.buttons.options = this.addChild(new Button('buttons/buttons/options', -385, 23, 0.65));

        /* GAMBLE GAME BUTTONS */
        // collects the last win amount
        this.buttonsGamble.collect = this.addChild(new Button('buttons/buttons/collect', 0, -62, 0.65, () => {
            NetworkController.takeWinAmount();
            this.collectCoins();
            this.switchToRegularGame();
        }));
        this.buttonsGamble.collect.hitArea = new PIXI.RoundedRectangle(-63, -15, 126, 63, 32);
        this.buttonsGamble.collect.text = Static.writeNativeText(this.buttonsGamble.collect, I18.f('take'), 'lato-regular', 0, 30, {
            fill: 0xfcd781,
            align: ALIGN.CENTER,
            weight: 'bold',
            size: 20,
        });
        Static.setScaleToFitWidthNativeText(this.buttonsGamble.collect.text, 100, 0.5, 1);


        this.buttonsGamble.startGamble = this.addChild(new Button('buttons/buttons/gamble', 0, 2, 0.65, () => {
            for (const key in this.buttonsGamble) {
                const btn = this.buttonsGamble[key];
                btn.visible = false;
            }
            this.startGambleGame();
        }));
        this.buttonsGamble.startGamble.hitArea = new PIXI.RoundedRectangle(-63, -47, 126, 63, 32);
        this.buttonsGamble.startGamble.text = Static.writeNativeText(this.buttonsGamble.startGamble, I18.f('gamble'), 'lato-regular', 0, -30, {
            fill: 0xfcd781,
            align: ALIGN.CENTER,
            weight: 'bold',
            size: 20,
        });

        this.balance = this.addChild(new Sprite());
        this.balance.position.set(312, 22);
        this.balance.balance = Static.writeNativeText(this.balance, `${I18.f('balance')} :`, 'lato-regular', 0, 0, {
            fill: 0xfcd781,
            size: 12,
            align: ALIGN.RIGHT,
            weight: 'bold',
        });
        this.balance.amount = DynamicData.writeNativeText(this.balance, GAME_DATA_KEY.COINS, 'lato-regular', 2, 0, {
            spaceDivider: true,
            fill: 0xfcd781,
            align: ALIGN.LEFT,
            weight: 'bold',
            size: 12,
        }, null, {
            width: 90,
            minScale: 0.5,
            maxScale: 1,
        });

        this.resizeUI(APP.layout.calculatedSize);
        APP.layout.on('fitlayout', this.resizeUI.bind(this));

        this.switchToRegularGame();
    }

    /**
   * @name switchToRegularGame
   * @description swith to regular game view zone
   */
    switchToRegularGame() {
        if (this.buttons.turbo) {
            this.buttons.turbo.visible = true;
        }
        this.buttons.spin.visible = true;

        for (const key in this.buttonsGamble) {
            const btn = this.buttonsGamble[key];
            btn.visible = false;
        }
    }

    /**
   * @name switchToGambleGame
   * @description swith to regular gamble view zone
   */
    switchToGambleGame() {
        // if (this.buttons.turbo) {
        //   this.buttons.turbo.visible = false;
        // }
        this.buttons.spin.visible = false;

        for (const key in this.buttonsGamble) {
            const btn = this.buttonsGamble[key];
            btn.visible = true;
        }
    }

    /**
   * @name disableButtons
   * @description disable buttons when spinning reel and auto spin is on
   */
    disableButtons() {
        for (const key in this.buttons) {
            const button = this.buttons[key];
            if (button === this.buttons.autoButton || button === this.buttons.turbo || button === this.buttons.options) { continue; }
            button.disable();
        }

        for (const key in this.switchers) {
            const sw = this.switchers[key];
            sw.disable();
        }
    }

    /**
   * @name enableButtons
   * @description enable button
   */
    enableButtons() {
        for (const key in this.buttons) {
            const button = this.buttons[key];
            if (button === this.buttons.autoButton || button === this.buttons.turbo || button === this.buttons.options) { continue; }
            if (GameData.getProperty(GAME_PROPERTY_KEY.AUTOSPIN) && (button === this.buttons.info)) {
                continue;
            }
            button.enable();
        }

        if (!(GameData.getProperty(GAME_PROPERTY_KEY.AUTOSPIN) || GameData.getProperty(GAME_PROPERTY_KEY.FREEGAME) || DynamicData.getData(GAME_DATA_KEY.SPECIALSPIN).freeSpins > 0)) {
            for (const key in this.switchers) {
                const sw = this.switchers[key];
                sw.enable();
            }
        }
    }

    hideBet() {
        this.betPanel.visible = false;
        this.switchers.s1.visible = false;
        this.switchers.s2.visible = false;
    }

    showBet() {
        this.betPanel.visible = true;
        this.switchers.s1.visible = true;
        this.switchers.s2.visible = true;
    }

    /**
   * @name collectCoins
   * @description collect winning coins
   */
    collectCoins() {
        if (this.isCollected) { return; }

        const GET = Utils.parseGet();
        if (GET.debug && !GameData.getProperty('demoPlay')) { NetworkController.takeWinAmount(); }

        if (!GameData.getProperty('isFreeGame') && !GameData.getProperty('freeGamePreStart')) {
            DynamicData.addValue('coins', DynamicData.getValue('lastWin'));
        }

        if (DynamicData.getData(GAME_DATA_KEY.SPECIALSPIN).freeSpins > 0) {
            TextPanel.sendMessage('duringSpecialSpin');
        }

        this.isCollected = true;
    }

    /**
   * @name startGambleGame
   * @description start gamble game and gamble view zone
   */
    startGambleGame() {
        if (this.buttons.turbo) {
            this.buttons.turbo.visible = false;
        }
        this.buttons.spin.visible = false;
        this.disableButtons();

        BigWin.stop(() => {
            this.gambleGameScreen = this.addChild(new GambleGame());
            this.gambleGameScreen.zIndex = -1;
            this.gambleGameScreen.exitHandler = () => {
                this.endGambleGame();
            };
        });
    }

    /**
   * @name endGambleGame
   * @description end gamble game and close gamble view zone
   */
    endGambleGame() {
        if (!this.gambleGameScreen) { return; }

        this.gambleGameScreen.finish();
        this.gambleGameScreen = null;
        this.collectCoins();
        this.enableButtons();
        this.switchToRegularGame();
    }

    /**
   * @name openFGWindow
   * @param type
   * @param callback
   * @description open free spin window and gift spin
   */
    openFGWindow(type, callback) {
        if (this.popup) { return; }

        GameData.setProperty('isPopupDialogueOpen', true);

        this.popupCallback = callback;

        const languages = ['en', 'de', 'es', 'fr', 'it', 'nl', 'pl', 'ru', 'tr', 'cs'];
        const GET = Utils.parseGet();
        let locale = GET.locale ? GET.locale.substr(0, 2) : '';
        if (languages.indexOf(locale) < 0) { locale = languages[0]; }

        this.popup = this.addChild(new ScreenLocker());
        this.popup.scale.set(0.65);
        this.popup.scaleTo(1, GameConfig.layoutFadeInOutTime);

        let autoCloseTimer = null;

        switch (type) {
            case 'startGS':
                this.popup.back = this.popup.addChild(APP.library.getSprite('free_games/FG-back'));
                break;
            case 'endGS':
                this.popup.back = this.popup.addChild(APP.library.getSprite('free_games/FG-back'));
                break;
            case 'startFG':
                this.popup.back = this.popup.addChild(APP.library.getSprite('free_games/freespin/freespin-back'));
                this.popup.glow = this.popup.back.addChild(APP.library.getSprite('free_games/freespin/glow'));
                this.popup.freeText = this.popup.back.addChild(APP.library.getSprite(`free_games/freespin/${locale}/free-spins`));
                this.popup.wonText = this.popup.back.addChild(APP.library.getSprite(`free_games/freespin/${locale}/you-won`));
                break;
            case 'addFG':
                this.popup.back = this.popup.addChild(APP.library.getSprite(`free_games/add_freespin/${locale}`));
                break;
            case 'endFG':
                this.popup.back = this.popup.addChild(APP.library.getSprite(`free_games/freespin_end/${locale}`));
                break;
            default:
                console.error(`Экран со строкой ${type} не задан.`);
        }

        this.popup.back.scale.set(1.2);
        this.popup.y = this.expandingBookPosition.start.y;
        if (type === 'addFG') {
            this.popup.y = this.expandingBookPosition.start.y - 30;
            this.popup.back.scale.set(1.3);
        }

        let timeout;

        this.popup.header = Static.writeText(this.popup, '', 'font_gold5', 0, -100);

        this.popup.redText = Static.writeText(this.popup, '', 'font_num_red', -50, -20);
        this.popup.redText.align = ALIGN.LEFT;
        this.popup.redText.valign = VALIGN.MIDDLE;

        this.popup.mainText = Static.writeText(this.popup, '', 'font_brown', -45, -15, {
            spaceDivider: true,
        });
        this.popup.mainText.scale.set(1);
        this.popup.mainText.align = ALIGN.LEFT;
        this.popup.mainText.valign = VALIGN.MIDDLE;

        this.popup.button = this.popup.addChild(new Button('free_games/FG-start-btn', 0, 60, 1.2, () => {
            if (type == 'startFG') {
                this.closeFGWindow(false);
            } else {
                this.closeFGWindow();
            }
            if (autoCloseTimer) { clearTimeout(autoCloseTimer); }
        }));
        this.popup.button.text = Static.writeText(this.popup.button, '', 'font_button_07', 0, -5);
        let count;
        switch (type) {
            case 'startGS':
                this.popup.header.write(I18.f('youWon'));
                this.popup.redText.write(divideDigits(DynamicData.getValue('GSCounter')));
                this.popup.mainText.write(divideDigits(I18.f('giftSpins')));
                this.popup.button.text.write(I18.f('start'));
                if (GameData.getProperty('isAutospin')) {
                    // TextPanel.sendMessage('finalCountdown');
                    timeout = GameConfig.autospinPopupClosingTime;
                }
                break;
            case 'endGS':
                this.popup.header.write(I18.f('GSoverHeader'));
                Static.writeText(this.popup.back, I18.f('featureCompleted'), 'font_gold4', 0, 0);
                timeout = 3000;
                this.popup.button.visible = false;
                break;
            case 'startFG':
                count = GameConfig.autospinPopupClosingTime / 1000 - 1;
                this.popup.back.scale.set(1.8);
                this.popup.wonText.y = -50;
                this.popup.wonText.x = -5;
                this.popup.freeText.y = 10;
                this.popup.button.y = 160;
                if (GameData.getProperty('isAutospin') && !GameData.getProperty('isTurboChecked')) {
                    this.popup.button.text.write(`${I18.f('start')} (${count})`);
                } else {
                    this.popup.button.text.write(I18.f('start'));
                }
                this.popup.button.text.setScaleToFitWidth(this.popup.button.width - 20, 0.1, 0.7);
                if (GameData.getProperty('isAutospin')) {
                    autoCloseTimer = setInterval(() => {
                        count--;
                        this.popup.button.text.write(`${I18.f('start')} (${count})`);
                        if (count === 0) {
                            clearTimeout(autoCloseTimer);
                        }
                    }, 1000);
                    if (GameData.getProperty('isTurboChecked')) {
                        clearTimeout(autoCloseTimer);
                        timeout = 900;
                    } else {
                        timeout = GameConfig.autospinPopupClosingTime;
                    }
                }

                break;
            case 'addFG':
                this.popup.button.visible = false;
                timeout = 4000;
                UI.showFreeWinText(this.expandingBook);
                break;
            case 'endFG':
                const win = DynamicData.getValue('FGWin');
                count = GameConfig.autospinPopupClosingTime / 1000 - 1;
                this.popup.mainText.write(divideDigits(win || 0));
                this.popup.mainText.align = ALIGN.CENTER;
                this.popup.mainText.x = 0;
                this.popup.mainText.y = 30;
                this.popup.mainText.scale.set(1.3);
                this.popup.button.y = 150;
                if (GameData.getProperty('isAutospin') && !GameData.getProperty('isTurboChecked')) {
                    this.popup.button.text.write(`${I18.f('collect')} (${count})`);
                } else {
                    this.popup.button.text.write(I18.f('collect'));
                }
                this.popup.button.text.setScaleToFitWidth(this.popup.button.width - 20, 0.1, 0.7);
                if (GameData.getProperty('isAutospin')) {
                    autoCloseTimer = setInterval(() => {
                        count--;
                        this.popup.button.text.write(`${I18.f('collect')} (${count})`);
                        if (count === 0) {
                            clearTimeout(autoCloseTimer);
                        }
                    }, 1000);
                    if (GameData.getProperty('isTurboChecked')) {
                        clearTimeout(autoCloseTimer);
                        timeout = 900;
                    } else {
                        timeout = GameConfig.autospinPopupClosingTime;
                    }
                }

                break;
            default:
                console.error(`Экран со строкой ${type} не задан.`);
        }

        this.popup.redText.setScaleToFitWidth(270, 0.1, 1);

        if (type != 'endFG') {
            const totalWidth = this.popup.redText.getWidth() * this.popup.redText.scale.x + this.popup.mainText.getWidth() * this.popup.mainText.scale.x + 6;
            this.popup.redText.x = -totalWidth / 2 - 8;
            this.popup.mainText.x = this.popup.redText.x + this.popup.redText.getWidth() * this.popup.redText.scale.x + 6;
        }

        function divideDigits(str) {
            let digitsCounter = 0;
            const arr = [];
            (function write(string) {
                const symbol = string.pop();

                if (!isNaN(+symbol)) { digitsCounter++; } else { digitsCounter = 0; }

                arr.unshift(symbol);

                if (digitsCounter && digitsCounter % 3 === 0) { arr.unshift(' '); }
                if (string.length) { write(string); }
            }((`${str}`).split('')));

            return arr.join('').trim();
        }

        if (timeout) {
            this.closingFGTimer = setTimeout(() => {
                this.closeFGWindow();
            }, timeout);
        }
    }

    /**
   * @name closeFGWindow
   * @description close free spin window and gift spin
   */
    closeFGWindow(isFadeOut = true) {
        if (this.popup) {
            if (isFadeOut) {
                this.popup.scaleTo(0.65, GameConfig.layoutFadeInOutTime, null, () => {
                    this.popup.safeRemove();
                    if (this.closingFGTimer) { clearTimeout(this.closingFGTimer); }
                    this.popup = null;
                });
            } else {
                this.popup.safeRemove();
                if (this.closingFGTimer) { clearTimeout(this.closingFGTimer); }
                this.popup = null;
            }
        }
        if (this.popupCallback) {
            if (GameData.getProperty('expandingSymbol') !== false && DynamicData.getValue('FGCounter') === 0) {
                this.openExpandingWindow(() => {
                    GameData.setProperty('freeGamePreStart', false);
                    if (this.popupCallback) {
                        this.popupCallback();
                    }
                });
            } else {
                GameData.setProperty('freeGamePreStart', false);
                this.popupCallback();
            }
        }
        GameData.setProperty('isPopupDialogueOpen', false);
    }

    /**
   * @name openExpandingWindow
   * @description open expanding symbol window and show animation of book scroll
   */
    openExpandingWindow(callback) {
        this.expandingWindow = this.addChild(new ScreenLocker());

        this.expandingCallback = callback;

        AudioManager.playSound('fx', 'free_games_window');

        this.expandingBook = this.addChild(APP.library.getSprite('free_games/expanding-book'));
        this.expandingBook.y = this.expandingBookPosition.start.y;
        this.expandingBook.scale.set(1.8);

        const symbolNumber = GameData.getProperty('expandingSymbol');

        this.expandingBook.textContainer = this.expandingBook.addChild(new Sprite());

        const pages = this.expandingBook.addChild(APP.library.getSprite('free_games/rolling'));
        pages.gotoAndPlay(0);
        pages.scale.set(0.993);
        pages.position.set(2, -27);
        pages.animationSpeed = 1.2;
        pages.zIndex = 100;

        let randomSymbolCounter = -1;

        function getRandomSymbol(pages) {
            randomSymbolCounter++;
            if (randomSymbolCounter === symbolNumber) { randomSymbolCounter++; }
            if (randomSymbolCounter > 8) { randomSymbolCounter = 0; }
            return UI.setFreeRightPage(pages, randomSymbolCounter);
        }

        let randomSymbol;
        let randomPaytable;

        this.isExpStopped = false;
        let counter = 0;
        const maxCounter = 10;

        pages.on('changeframe', (e) => {
            if (e.frame == 7) {
                if (counter === maxCounter) {
                    UI.setFreeRightPage(pages, symbolNumber);
                } else {
                    if (counter < 4) {
                        pages.animationSpeed = 1;
                    } else if (counter < 7) {
                        pages.animationSpeed = 0.8;
                    } else if (counter < 9) {
                        pages.animationSpeed = 0.4;
                    } else {
                        pages.animationSpeed = 0.2;
                    }
                    randomSymbol = getRandomSymbol(pages);
                }
            }

            if (e.frame == 0) {
                if (randomSymbol) { randomSymbol.safeRemove(); }
                if (counter === maxCounter) {
                    UI.showFreeWinText(this.expandingBook.textContainer);
                }
            }

            if (e.frame == 15) {
                if (counter === maxCounter) {
                    pages.stop();
                    pages.gotoAndStop(15);
                    setTimeout(() => {
                        if (this.expandingWindow) {
                            this.shiftExpanding(this.expandingCallback);
                        }
                    }, GameConfig.autospinExpandingBookClosingTime);
                } else {
                    pages.gotoAndPlay(0);
                    counter++;
                }
                if (this.isExpStopped) { counter = maxCounter; }
            }
        });

        this.expandingWindow.on('pointerclick', () => {
            this.onClickHandlerExpanding(this.expandingCallback);
        });
    }

    /**
   * @name setFreeRightPage
   * @description set paytable and show that paytable with expanding symbol
   */
    static setFreeRightPage(parent, symbolNumber) {
        const rightPage = parent.addChild(new Sprite());

        const symbolAssets = [
            'expanding/Low_10_symbol',
            'expanding/Low_J_symbol',
            'expanding/Low_Q_symbol',
            'expanding/Low_K_symbol',
            'expanding/Low_A_symbol',
            'expanding/Hi_05',
            'expanding/Hi_04',
            'expanding/Hi_03',
            'expanding/Hi_02',
        ];

        let src = symbolAssets[symbolNumber];
        let asset;
        if (Array.isArray(src)) {
            src = src[0];
            asset = src.map(e => APP.library.getAsset(e));
        } else {
            asset = APP.library.getAsset(src);
        }
        const symbol = rightPage.addChild(new Sprite(asset));

        symbol.gotoAndStop(0);
        symbol.zIndex = 50;
        symbol.alpha = 1;
        symbol.scale.set(0.35);
        symbol.position.set(55, -8);
        symbol.play();

        const randomPaytable = rightPage.addChild(new Sprite());
        const income = GameConfig.symbolIncome[symbolNumber].slice(0).map(e => e * DynamicData.getValue('bet'));
        const yPositions = income[0] === 0 ? [0, 55, 40, 25] : [65, 50, 35, 20];

        const maxWidth = 0;
        for (let i = income.length - 1; i >= 0; i--) {
            const val = income[i];
            if (val) {
                Static.writeText(randomPaytable, i + 2, 'font_pay_table_num_07', 28, yPositions[i], {
                    scale: 0.9,
                });
                Static.writeNativeText(randomPaytable, '-', 'myriad', 35, yPositions[i] - 6, {
                    fill: '#370202',
                    weight: 'bold',
                    align: ALIGN.LEFT,
                    valign: VALIGN.BOTTOM,
                    size: 10,
                });
                Static.writeNativeText(randomPaytable, val, 'myriad', 41, yPositions[i] - 5, {
                    fill: '#370202',
                    weight: 'bold',
                    size: 10,
                    align: ALIGN.LEFT,
                    valign: VALIGN.BOTTOM,
                    spaceDivider: true,
                });
            }
        }
        randomPaytable.scale.set(1.1);
        randomPaytable.position.set(0, 3);


        let duration = 100;
        if (parent.animationSpeed >= 0.4) {
            duration = 300;
        } else {
            duration = 600;
        }

        rightPage.position.set(0, 0);
        rightPage.scale.set(0.15, 1);
        rightPage.alpha = 0.2;
        rightPage.skew.set(0.1, -0.15);

        rightPage.moveTo(0, 0, duration);
        rightPage.scaleXTo(1, duration);
        rightPage.fadeTo(1, duration);
        rightPage.skewXTo(0, duration);
        rightPage.skewYTo(0, duration);

        return rightPage;
    }

    /**
   * @name showFreeWinText
   * @description show 10 freespin text
   */
    static showFreeWinText(parent) {
        if (parent.textContainer) {
            parent.textContainer.safeRemove();
        }
        parent.textContainer = parent.addChild(new Sprite());
        Static.writeText(parent.textContainer, DynamicData.getData(GAME_DATA_KEY.FREESPIN).freeSpins, 'font_num_red', -50, -30, {
            width: 100,
            align: ALIGN.CENTER,
            scale: 0.9,
        });
        Static.writeText(parent.textContainer, I18.f('tpTriggerFG'), 'font_brown', -50, 15, {
            width: 100,
            align: ALIGN.CENTER,
            scale: 0.6,
        });

        parent.textContainer.scale.set(1.2);
    }

    /**
   * @name shiftExpanding
   * @description shift expanding symbole popup to corner
   */
    shiftExpanding(callback) {
        if (this.expandingWindow) {
            this.expandingWindow.safeRemove();
            this.expandingWindow = null;
        }
        // this.expandingBook.moveTo(
        //   0,
        //   -200, 500);
        // this.expandingBook.scaleTo(1.8, 500, null, () => {
        //   this.enableButtons();
        //   if (callback) callback();
        // });

        this.expandingBook.moveTo(
            this.expandingBookPosition.end.x,
            this.expandingBookPosition.end.y, 500,
        );
        this.expandingBook.scaleTo(this.expandingBookPosition.end.scale * 0.8, 500, null, () => {
            this.enableButtons();
            if (callback) { callback(); }
        });
    }

    onClickHandlerExpanding() {
        !this.isExpStopped ? this.isExpStopped = true : this.shiftExpanding.call(this, this.expandingCallback);
    }

    /**
   * @name closeExpanding
   * @description close expanding symbol window
   */
    closeExpanding() {
        if (this.expandingWindow) { this.expandingWindow.safeRemove(); }
        if (this.expandingBook) { this.expandingBook.safeRemove(); }
    }

    /**
   * @name openInfo
   * @description open paytable window
   */
    openInfo() {
        this.paytable = Paytable.invoke(0, -242);
        if (this.paytable) {
            this.addChild(this.paytable);
        }
    }
}

export default UI;
